<section class="hero-section os-blue-800">
  <h1>Welcome to 503B.com</h1>
  <p>
    <span class="callout os-blue-400">Streamlining</span> the 503B Outsourcing
    Facility procurement process for pharmacies
  </p>
</section>
<div class="circle-section">
  <span class="small-circle"></span>
  <span class="big-circle"></span>
  <span class="small-circle"></span>
</div>
<section class="second-section">
  <img
    class="second-section-image"
    src="/assets/img/static-pages/503B/static-pages-header-icons/503B_Products.svg"
    alt=""
  />
  <div class="second-section-copy">
    <p>
      Regulated by the U.S. Food and Drug Administration (FDA), 503B Outsourcing
      Facilities supply compounded medications for use in hospitals, clinics,
      and physicians' offices. <span class="callout bule-400">503B.com</span> is
      direct a sourcing channel designed for pharmacies to review each
      facility's most recent credentials,
      <span class="callout os-blue-400">provide transparency</span> into product
      availability, and it offers an easy way to generate direct purchase
      orders.
    </p>
    <button class="second-section-cta bg-os-blue-300">
      <a href="/register" class="white">Register Now</a>
    </button>
  </div>
</section>
<section class="third-section bg-os-blue-800">
  <div class="left-side">
    <h2 class="third-section-title white">
      Why <span class="os-blue-400">503B.com?</span>
    </h2>
    <p class="third-section-copy white">
      503B.com delivers digital access to pharmaceutical products from a
      community of Outsourcing Facilities through an intuitive, and secure user
      interface.
    </p>
  </div>
  <div>
    <ul class="third-section-list">
      <li class="third-section-bullet">
        <img
          src="/assets/img/static-pages/503B/static-pages-icons/Lock_Icon.svg"
          alt="Open lock icon"
        />
        <p class="white">
          Authorized pharmacies have insight into 503B products and pricing
        </p>
      </li>
      <li class="third-section-bullet">
        <img
          src="/assets/img/static-pages/503B/static-pages-icons/503B_Truck.svg"
          alt="Truck icon"
        />
        <p class="white">
          Compliant product pedigree (all orders are shipped from the
          Outsourcing Facility)
        </p>
      </li>
      <li class="third-section-bullet">
        <img
          src="/assets/img/static-pages/503B/static-pages-icons/503B_Pill.svg"
          alt="Pill icon"
        />
        <p class="white">Request drug shortages with a few clicks</p>
      </li>
      <li class="third-section-bullet">
        <img
          src="/assets/img/static-pages/503B/static-pages-icons/503B_Stopwatch.svg"
          alt="Notepad Icon"
        />
        <p class="white">
          Simple, free online registration for pharmacies (5 minutes)
        </p>
      </li>
      <li class="third-section-bullet">
        <img
          src="/assets/img/static-pages/503B/static-pages-icons/Door_Icon.svg"
          alt="Welcoming door icon"
        />
        <p class="white">
          Single sign-in for access to multiple Outsourcing Facilities
        </p>
      </li>
    </ul>
  </div>
</section>
<section class="fourth-section" id="contact-us">
  <h2 class="fourth-section-title os-blue-300">Questions?</h2>
  <h3 class="fourth-sction-sub-title os-blue-700">We're here to help!</h3>
  <app-static-footer></app-static-footer>
</section>
